import { render, staticRenderFns } from "./upload-history.vue?vue&type=template&id=28e92a55&scoped=true"
import script from "./upload-history.vue?vue&type=script&lang=js"
export * from "./upload-history.vue?vue&type=script&lang=js"
import style0 from "./upload-history.vue?vue&type=style&index=0&id=28e92a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e92a55",
  null
  
)

export default component.exports